function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "3-level2_svg__b",
  x1: 49.76,
  y1: 84.1,
  x2: 29.49,
  y2: -10.68,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#23c386"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#80e8bb"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "3-level2_svg__a",
  x1: 23.3,
  y1: -6.69,
  x2: 41.56,
  y2: 40.38,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#007763"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#23c386"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "3-level2_svg__c",
  x1: 48.56,
  y1: 68.85,
  x2: 35.7,
  y2: 21.69,
  xlinkHref: "#3-level2_svg__a"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#3-level2_svg__b)",
  d: "M65.85 18.28L58.51 0 39 2.78 19.5 0l-7.35 18.28L0 33.78l12.15 15.5 7.34 18.28L39 64.78l19.51 2.78 7.34-18.28L78 33.78l-12.15-15.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39 11.13a22.65 22.65 0 1022.65 22.65A22.65 22.65 0 0039 11.13z",
  fill: "url(#3-level2_svg__a)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39 15.76a18 18 0 1018 18 18 18 0 00-18-18z",
  fill: "url(#3-level2_svg__c)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.14 32.18A3.67 3.67 0 0139 27.67c2.46 0 4 1.6 4 3.51a3.81 3.81 0 01-2.11 3.33l-2 1.2a1.87 1.87 0 00-.73.72h5v2.18H35a4.88 4.88 0 012.52-4.71l1.75-1c.84-.49 1.17-.94 1.17-1.64A1.28 1.28 0 0039 30a1.43 1.43 0 00-1.5 1.58 2.21 2.21 0 00.1.66z",
  fill: "#fff"
}));

function Svg3Level2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 78 67.56"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2aWV3Qm94PSIwIDAgNzggNjcuNTYiPjxkZWZzPjxsaW5lYXJHcmFkaWVudCBpZD0iYiIgeDE9IjQ5Ljc2IiB5MT0iODQuMSIgeDI9IjI5LjQ5IiB5Mj0iLTEwLjY4IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHN0b3Agb2Zmc2V0PSIwIiBzdG9wLWNvbG9yPSIjMjNjMzg2Ii8+PHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjODBlOGJiIi8+PC9saW5lYXJHcmFkaWVudD48bGluZWFyR3JhZGllbnQgaWQ9ImEiIHgxPSIyMy4zIiB5MT0iLTYuNjkiIHgyPSI0MS41NiIgeTI9IjQwLjM4IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHN0b3Agb2Zmc2V0PSIwIiBzdG9wLWNvbG9yPSIjMDA3NzYzIi8+PHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjMjNjMzg2Ii8+PC9saW5lYXJHcmFkaWVudD48bGluZWFyR3JhZGllbnQgaWQ9ImMiIHgxPSI0OC41NiIgeTE9IjY4Ljg1IiB4Mj0iMzUuNyIgeTI9IjIxLjY5IiB4bGluazpocmVmPSIjYSIvPjwvZGVmcz48ZyBkYXRhLW5hbWU9IkxheWVyIDIiPjxwYXRoIGZpbGw9InVybCgjYikiIGQ9Ik02NS44NSAxOC4yOEw1OC41MSAwIDM5IDIuNzggMTkuNSAwbC03LjM1IDE4LjI4TDAgMzMuNzhsMTIuMTUgMTUuNSA3LjM0IDE4LjI4TDM5IDY0Ljc4bDE5LjUxIDIuNzggNy4zNC0xOC4yOEw3OCAzMy43OGwtMTIuMTUtMTUuNXoiLz48cGF0aCBkPSJNMzkgMTEuMTNhMjIuNjUgMjIuNjUgMCAxMDIyLjY1IDIyLjY1QTIyLjY1IDIyLjY1IDAgMDAzOSAxMS4xM3oiIGZpbGw9InVybCgjYSkiLz48cGF0aCBkPSJNMzkgMTUuNzZhMTggMTggMCAxMDE4IDE4IDE4IDE4IDAgMDAtMTgtMTh6IiBmaWxsPSJ1cmwoI2MpIi8+PHBhdGggZD0iTTM1LjE0IDMyLjE4QTMuNjcgMy42NyAwIDAxMzkgMjcuNjdjMi40NiAwIDQgMS42IDQgMy41MWEzLjgxIDMuODEgMCAwMS0yLjExIDMuMzNsLTIgMS4yYTEuODcgMS44NyAwIDAwLS43My43Mmg1djIuMThIMzVhNC44OCA0Ljg4IDAgMDEyLjUyLTQuNzFsMS43NS0xYy44NC0uNDkgMS4xNy0uOTQgMS4xNy0xLjY0QTEuMjggMS4yOCAwIDAwMzkgMzBhMS40MyAxLjQzIDAgMDAtMS41IDEuNTggMi4yMSAyLjIxIDAgMDAuMS42NnoiIGZpbGw9IiNmZmYiLz48L2c+PC9zdmc+";
export { Svg3Level2 as ReactComponent };